import React from 'react'
import {middleGray} from '../../conf'

const emptyWhiteRow = () => {
    return (
        <div style={{height: "20px", marginTop: "-2px", backgroundColor: middleGray}}/>
    );
}

export default emptyWhiteRow;